import { ModelSagres } from "@/types/model-sagres";

export class Classificado extends ModelSagres {
  IdClassificado: number;
  IdEditalCargo: number | null;
  IdTipoClassificado: number | null;
  NrClassificacao: number;
  CpfClassificado: string;
  NomeClassificado: string;
  IdTipoClassificadoNavigation: {
    DsTipoClassificado: string;
    IdTipoClassificado: number;
  };
  IdCargoProcessoSeletivoNavigation: {
    IdCargoProcessoSeletivo: number,
    DsNomenclatura: string
  }

  constructor(obj?: any) {
    super();
    if (obj) {
      this.IdClassificado = obj.IdClassificado;
      this.IdEditalCargo = obj.IdEditalCargo;
      this.IdTipoClassificado = obj.IdTipoClassificado;
      this.NrClassificacao = obj.NrClassificacao;
      this.CpfClassificado = obj.CpfClassificado;
      this.NomeClassificado = obj.NomeClassificado;
      this.IdTipoClassificadoNavigation = {
        DsTipoClassificado: obj.IdTipoClassificadoNavigation.DsTipoClassificado,
        IdTipoClassificado: obj.IdTipoClassificadoNavigation.IdTipoClassificado,
      };
      this.IdCargoProcessoSeletivoNavigation = {
        IdCargoProcessoSeletivo: obj.IdCargoProcessoSeletivoNavigation?.IdCargoProcessoSeletivo,
        DsNomenclatura: obj.IdCargoProcessoSeletivoNavigation?.DsNomenclatura,
      }
    }
  }
}
